import axios from "axios";
import Cookies from "js-cookie";
import {
  onRegistration,
  onTrialPurchased,
  onRegularFreeTrialActions
} from "@/scripts/helpers/googleAnalyticsEvents";
import MicroModal from "micromodal";

export default () => {
  const googleOneTap = $(".google-one-tap");
  const googleOneTapForm = $(".google-one-tap-forms");
  const token = $("meta[name='csrf-token']").attr("content");
  const pageUrl = window.location.pathname;

  if (googleOneTap.length) {
    window.onload = function() {
      const clientID =
        process.env.NODE_ENV === "production"
          ? "503458506158-ik55q8icsg2icen0t4qkr6a7uucoknug.apps.googleusercontent.com"
          : "799622306347-f6ahms0p90ub7o0cb2geqavlulinqr7d.apps.googleusercontent.com";
      google.accounts.id.initialize({
        client_id: clientID,
        callback: handleCredentialResponse
      });
      google.accounts.id.prompt((notification) => {
        if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
          axios({
            method: "post",
            url: `/api/v1/metrics/google-one-tap-not-displayed`,
            data: {
              login_status: "isNotDisplayed",
              page_url: pageUrl
            },
            dataType: "json",
            headers: { "X-CSRF-TOKEN": token},
            withCredentials: false
          });
        } else {
          axios({
            method: "post",
            url: `/api/v1/metrics/google-one-tap-show`,
            data: {
              login_status: "isDisplayed",
              page_url: pageUrl
            },
            dataType: "json",
            headers: { "X-CSRF-TOKEN": token},
            withCredentials: false
          });
        }
      });
    };

    function handleCredentialResponse(data) {
      axios({
        method: "post",
        url: `/api/v1/metrics/google-one-tap-click`,
        data: {
          login_status: true,
          page_url: pageUrl
        },
        dataType: "json",
        headers: { "X-CSRF-TOKEN": token},
        withCredentials: false
      });

      const pathDomain =
        process.env.NODE_ENV === "production"
          ? ".signnow.com"
          : ".signnow-dev.xyz";

      Cookies.remove("XSRF-TOKEN", { secure: false, domain: `${pathDomain}` });

      const path =
        process.env.NODE_ENV === "production"
          ? "https://app.signnow.com/auth/v1/sessions/social"
          : "https://app3.signnow-dev.xyz/auth/v1/sessions/social";

      axios
        .post(
          path,
          {
            token: data.credential,
            provider: "google"
          },
          { withCredentials: true }
        )
        .then(res => {
          if (res.data.social_reg) {
            onRegistration();
            onTrialPurchased();
            onRegularFreeTrialActions("Google One Tap", "Sign-up");
          } else if (res.data.social_reg === false) {
            onRegularFreeTrialActions("Google One Tap", "Login");
          }

          axios({
            method: "post",
            url: `/event/google-one-tap-login-event`,
            data: {
              login_status: true,
              page_url: pageUrl
            },
            dataType: "json",
            headers: { "X-CSRF-TOKEN": token},
            withCredentials: false
          });

          const pathUrl =
            process.env.NODE_ENV === "production"
              ? "https://app.signnow.com/webapp/folder"
              : "https://app3.signnow-dev.xyz/webapp/folder";

          window.location.href = pathUrl;
        })
        .catch(error => {
          axios({
            method: "post",
            url: `/api/v1/metrics/google-one-tap-fail`,
            data: {
              login_status: false,
              page_url: pageUrl
            },
            dataType: "json",
            headers: { "X-CSRF-TOKEN": token},
            withCredentials: false
          });
        });
    }
  }

  if (googleOneTapForm.length) {
    window.onload = function() {
      const clientID =
        process.env.NODE_ENV === "production"
          ? "503458506158-ik55q8icsg2icen0t4qkr6a7uucoknug.apps.googleusercontent.com"
          : "799622306347-f6ahms0p90ub7o0cb2geqavlulinqr7d.apps.googleusercontent.com";
      google.accounts.id.initialize({
        client_id: clientID,
        callback: handleCredentialResponse
      });
      google.accounts.id.prompt((notification) => {        
        if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
          axios({
            method: "post",
            url: `/api/v1/metrics/google-one-tap-forms-not-displayed`,
            data: {
              login_status: "isNotDisplayedOnForms",
              page_url: pageUrl
            },
            dataType: "json",
            headers: { "X-CSRF-TOKEN": token},
            withCredentials: false
          });
        } else {
          axios({
            method: "post",
            url: `/api/v1/metrics/google-one-tap-forms-show`,
            data: {
              login_status: "isDisplayedOnForms",
              page_url: pageUrl
            },
            dataType: "json",
            headers: { "X-CSRF-TOKEN": token},
            withCredentials: false
          });
        }
      });
    };

    function handleCredentialResponse(data) {
      axios({
        method: "post",
        url: `/api/v1/metrics/google-one-tap-forms-click`,
        data: {
          login_status: true,
          page_url: pageUrl
        },
        dataType: "json",
        headers: { "X-CSRF-TOKEN": token},
        withCredentials: false
      });

      const pathDomain =
        process.env.NODE_ENV === "production"
          ? ".signnow.com"
          : ".signnow-dev.xyz";

      Cookies.remove("XSRF-TOKEN", { secure: false, domain: `${pathDomain}` });

      const path =
        process.env.NODE_ENV === "production"
          ? "https://app.signnow.com/auth/v1/sessions/social"
          : "https://app3.signnow-dev.xyz/auth/v1/sessions/social";

      axios
        .post(
          path,
          {
            token: data.credential,
            provider: "google"
          },
          { withCredentials: true }
        )
        .then(res => {
          if (res.data.social_reg) {
            onRegistration();
            onTrialPurchased();
            onRegularFreeTrialActions("Google One Tap", "Sign-up");
          } else if (res.data.social_reg === false) {
            onRegularFreeTrialActions("Google One Tap", "Login");
          }

          axios({
            method: "post",
            url: `/event/google-one-tap-login-event`,
            data: {
              login_status: true,
              page_url: pageUrl
            },
            dataType: "json",
            headers: { "X-CSRF-TOKEN": token},
            withCredentials: false
          });

          const formId = $(
            ".page-section--greeting, .page-section--intro"
          ).attr("data-formId");
          const formLoader = () => {
            $.ajax({
              url: "/forms/get-editor-data",
              type: "POST",
              data: {
                id: formId
              },
              dataType: "json",
              headers: { "X-CSRF-TOKEN": token },

              success: function(data) {
                let editorUrl = data.editorUrl;
                setTimeout(() => {
                  window.location.href = editorUrl;
                }, 700);
              }
            });
          };

          $(".modal__button--back").click(function(e) {
            e.preventDefault();

            $.ajax({
              url: "/forms/get-editor-data",
              type: "POST",
              data: {
                id: formId
              },
              dataType: "json",
              headers: { "X-CSRF-TOKEN": token },
              success: function(data) {
                let editorUrl = data.editorUrl;

                setTimeout(() => {
                  window.open(editorUrl, "_blank");
                }, 700);
              }
            });
          });

          $(".modal__button--check").click(function(e) {
            axios({
              method: "post",
              url: `/api/v1/metrics/google-one-tap-popup-signnow`,
              data: {},
              dataType: "json",
              headers: { "X-CSRF-TOKEN": token},
              withCredentials: false
            });
          });

          if ($("#modal-registration").length) {
            MicroModal.show("modal-registration");
          } else {
            formLoader();
          }
        })
        .catch(error => {
          axios({
            method: "post",
            url: `/api/v1/metrics/google-one-tap-forms-fail`,
            data: {
              login_status: false,
              page_url: pageUrl
            },
            dataType: "json",
            headers: { "X-CSRF-TOKEN": token},
            withCredentials: false
          });
        });
    }
  }
};
